import React from "react";
import { withRouter } from 'react-router-dom';
import styles from "./NavigationBar.module.scss";
import { ProgressBar } from "react-bootstrap";
import { useSelector } from "react-redux";

const NavigationBar = props => {
  const state = useSelector(state => state);
  const { form: formData } = state;
  const { application } = state;
  const { documents } = state;
  const { qualificationFilesUploadStatus, tradeFilesUploadStatus } = documents;
  const { applicationNo } = application
  const { form } = formData;
  const { pathname } = props.location;
  const justSteps = [...new Set(props.items.map(i => i.step))];
  const total = justSteps.length;
  const pn = pathname ? pathname.split('/') : [''];
  const digValueOut = (state, fields) => {
    if (!state || ({}).constructor !== state.constructor || !fields || !Array.isArray(fields) || !fields.length) {
      return state;
    }
    return digValueOut(state[fields.shift()], fields);
  }
  const indexify = arr => {
    for (let i = 0; i < arr.length; i++) {
      arr[i].index = i + 1;
    }
    return arr;
  }
  let items = [...props.items].filter(i => {
    if (!i.conditions)
      return true;
    else {
      return !!i.conditions.find(c => {
        const fields = c.state.split('.');
        const stateValue = digValueOut(state, fields);
        switch (c.condition) {
          case "in":
            return !!c.value.find(v => v === stateValue)
          case "equals":
            return c.value === stateValue
          case "not equals":
            return c.value !== stateValue
        }
      });
    }
  });
  items = indexify(items);
  let selectedItem = items.find(i => {
    let newUrl = !i.url.includes('{{form}}') ? i.url : i.url.replace("{{form}}", form);
    const url = newUrl ? newUrl.split('/') : [''];
    const num = url.filter(u => u.includes(":")).length + 1;
    return url[url.length - num] === pn[pn.length - num];
  });
  if (!selectedItem) {
    selectedItem = items.find(i => i.default);
  }

  const replaceParams = (str) => {
    let newStr = str;
    Object.keys(props.match.params).forEach(key => {
      var value = props.match.params[key];
      newStr = newStr.includes(`:${key}`) ? newStr.replace(`:${key}`, value) : newStr;
    });
    return newStr;
  }

  let previousItem = items.reduce((acc, i) => selectedItem && i.index < selectedItem.index ? i : acc, null);
  previousItem = previousItem ? { ...previousItem } : undefined;
  if (!previousItem) {
    if (selectedItem && selectedItem.back) {
      previousItem = {
        url: replaceParams(!selectedItem.back.includes('{{form}}') ? selectedItem
          .back : selectedItem.back.replace("{{form}}", form))
      }
    } else {
      previousItem = {
        url: props.startUrl ? props.startUrl : `/${pn[pn.length - 2]}`
      }
    }
  } else {
    previousItem.url = replaceParams(previousItem.url);
  }

  let isUploading = qualificationFilesUploadStatus === 'uploading' || tradeFilesUploadStatus === 'uploading';

  previousItem.url = !previousItem.url.includes('{{form}}') ? previousItem.url : previousItem.url.replace("{{form}}", form);
  const backButton = props.backUrl ? (<a
    className={isUploading ? styles.disabledback : styles.back}
    href={'javascript:void(0)'}
    onClick={() => props.history.push(props.backUrl)}
  >&#x3C;&nbsp;Back</a>) : (props.noHistoryBack ? <a
    className={isUploading ? styles.disabledback : styles.back}
    href={'javascript:void(0)'}
    onClick={() => props.history.push(previousItem.url)}
  >&#x3C;&nbsp;Back</a> : <a
    className={isUploading ? styles.disabledback : styles.back}
    href={'javascript:void(0)'}
    onClick={() => props.history.goBack()}
  >&#x3C;&nbsp;Back</a>);

  const selectedIndex = selectedItem ? selectedItem.index : 0;
  return <div className={styles.menuCont}>
    <div className={styles.container}>
      <div className={'row'}>
        <div className={`col-12 col-md-6 ${styles.title}`}>
          <h2 className={styles.navigationMainTitle}>{props.title}</h2>
        </div>
        <div className={`col-12 col-md-6 text-right ${styles.appnum}`}>
          <h2 className={styles.navigationMainAppNum}>{applicationNo}</h2>
        </div>
      </div>
      {previousItem ?
        <div className={styles.backCont}>
          {backButton}
        </div> : null}
      {total && total > 0 ? <div className={styles.steps}>Step {selectedIndex} of {total}</div> : null}
      <h1 className={styles.label}>{props.label ? props.label : (selectedItem ? selectedItem.label : '')}</h1>
      {selectedItem && selectedItem.sublabel ?
        <h3 className={styles.sublabel}>{selectedItem ? selectedItem.sublabel : ''}</h3> : null}
      {total && total > 0 ? <ProgressBar
        className={styles.progress}
        now={parseInt(100 / (total ?? items.length) * selectedIndex)}
      /> : null}
    </div>
  </div>;
};

export default withRouter(props => <NavigationBar {...props} />);
